import globalAxios from 'axios';
import { DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, toPathString, createRequestFunction } from '../common.js';
import { operationServerMap, BaseAPI, BASE_PATH } from '../base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * TmdbApi - axios parameter creator
 * @export
 */
const TmdbApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets the TMDb image configuration options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tmdbClientConfiguration: async (options = {}) => {
            const localVarPath = `/Tmdb/ClientConfiguration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TmdbApi - functional programming interface
 * @export
 */
const TmdbApiFp = function (configuration) {
    const localVarAxiosParamCreator = TmdbApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets the TMDb image configuration options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tmdbClientConfiguration(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.tmdbClientConfiguration(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['TmdbApi.tmdbClientConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * TmdbApi - factory interface
 * @export
 */
const TmdbApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TmdbApiFp(configuration);
    return {
        /**
         *
         * @summary Gets the TMDb image configuration options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tmdbClientConfiguration(options) {
            return localVarFp.tmdbClientConfiguration(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TmdbApi - object-oriented interface
 * @export
 * @class TmdbApi
 * @extends {BaseAPI}
 */
class TmdbApi extends BaseAPI {
    /**
     *
     * @summary Gets the TMDb image configuration options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TmdbApi
     */
    tmdbClientConfiguration(options) {
        return TmdbApiFp(this.configuration).tmdbClientConfiguration(options).then((request) => request(this.axios, this.basePath));
    }
}

export { TmdbApi, TmdbApiAxiosParamCreator, TmdbApiFactory, TmdbApiFp };
